import { Modal, Spinner, clubbiStyled } from 'clubbi-ui'

export const StyledModal = clubbiStyled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  border: 'none',
  padding: '16px 0px',

  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },

  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
  },
}))

export const StyledWrapper = clubbiStyled('div')(({ theme }) => ({
  width: 'calc(100% - 32px)',
  maxWidth: 512,
  maxHeight: 'calc(100vh - 64px)',
  borderRadius: 16,
  backgroundColor: theme.palette.brandWhite.main,
  boxShadow: '0px 8px 24px rgba(25, 28, 38, 0.15)',
  overflowY: 'auto',
}))

export const StyledHeader = clubbiStyled('div')(() => ({
  background: 'linear-gradient(90deg, #9810FA 0%, #8200DB 100%)',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  padding: 24,
  textAlign: 'left',
}))

export const StyledTitle = clubbiStyled('h2')(() => ({
  margin: 0,
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '32px',
}))

export const StyledContent = clubbiStyled('div')(() => ({
  padding: 24,
}))

export const StyledDescription = clubbiStyled('p')(() => ({
  margin: 0,
  color: '#3A465E',
  whiteSpace: 'pre-line',
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '26px',
}))

export const StyledWarningWrapper = clubbiStyled('div')(() => ({
  marginTop: 24,
  padding: 16,
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  backgroundColor: '#F4EFFA',
}))

export const StyledWarningIconWrapper = clubbiStyled('div')(() => ({
  width: 40,
  minWidth: 40,
  height: 40,
  borderRadius: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(90deg, #9810FA 0%, #8200DB 100%)',
  color: '#FFFFFF',
}))

export const StyledWarningText = clubbiStyled('p')(() => ({
  margin: 0,
  color: '#606C84',
  fontWeight: 400,
  fontSize: 18,
  lineHeight: '28px',
}))

export const StyledErrorMessage = clubbiStyled('p')(() => ({
  margin: 0,
  textAlign: 'center',
  marginTop: 16,
  color: '#EF8080',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '24px',
}))

export const StyledActions = clubbiStyled('div')(() => ({
  marginTop: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}))

export const StyledPrimaryButton = clubbiStyled('button')(() => ({
  height: 56,
  width: '100%',
  borderRadius: 10,
  border: 'none',
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 22,
  lineHeight: '30px',
  background: 'linear-gradient(90deg, #9810FA 0%, #8200DB 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    background: 'linear-gradient(90deg, #9810FA 0%, #8200DB 100%)',
    opacity: 0.95,
  },
}))

export const ButtonSpinner = clubbiStyled(Spinner)({
  width: '30px !important',
  height: '30px !important',
  color: '#FFFFFF !important',
})

const outlinedButtonStyles = {
  height: 56,
  width: '100%' as const,
  borderRadius: 10,
  background: '#FFFFFF',
  color: '#8E19F6',
  border: '1px solid #9810FA',
  fontWeight: 700,
  fontSize: 20,
  lineHeight: '28px',
  '&:hover': {
    backgroundColor: '#FFFFFF',
    border: '1px solid #9810FA',
  },
}

export const StyledSecondaryButton = clubbiStyled('button')(() => outlinedButtonStyles)
